import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayroll = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#83e4b1",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Payroll",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 15221",
				x: 1,
				y: 1.5,
				width: 14,
				height: 13,
				rx: 1.5,
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 4",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M6.08192 10.2843C6.3053 10.5781 6.59631 10.8137 6.93022 10.9709C7.26414 11.1282 7.63108 11.2025 7.99987 11.1875C9.17562 11.1875 10.1294 10.4722 10.1294 9.59064C10.1294 8.70908 9.17562 7.99373 7.99987 7.99373C6.82412 7.99373 5.87134 7.27837 5.87134 6.39579C5.87134 5.5132 6.82412 4.79888 7.99987 4.79888C8.36862 4.78419 8.73547 4.85862 9.06934 5.01585C9.40322 5.17308 9.69426 5.40848 9.91782 5.70211",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M7.99902 11.1935V12.2577",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M7.99902 3.74231V4.80554",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})]
		})
	})
});
export default SvgPayroll;
